/** Load optional /config.json served at runtime (Docker entrypoint or static file). */

export type RuntimeConfig = {
  mqttWsUrl?: string;
};

let cached: RuntimeConfig | null = null;

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (cached) return cached;
  try {
    const res = await fetch("/config.json", { cache: "no-store" });
    if (!res.ok) {
      cached = {};
      return cached;
    }
    cached = (await res.json()) as RuntimeConfig;
    return cached;
  } catch {
    cached = {};
    return cached;
  }
}
